import { useQueryClient } from '@tanstack/react-query';
import { useAxios } from 'hooks';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';
import { useCallback } from 'react';
import { filteredDeduped, IIntegratedEquipmentLocation, IIntegratedEquipmentLocationResponse } from '../utils/utils';

export function useIntegratedEquipmentLastKnown() {
  const axios = useAxios();
  const baseQueryKey = useReactQueryBaseKey();
  const queryClient = useQueryClient();

  return useCallback(
    async (enabled: boolean): Promise<IIntegratedEquipmentLocation[]> => {
      if (!enabled) {
        return [];
      }

      try {
        return await queryClient.fetchQuery({
          queryKey: [...baseQueryKey, 'integrated-equipment-location', 'last-known'],
          queryFn: async () => {
            const response = await axios.get<IIntegratedEquipmentLocationResponse>(
              '/integrated-equipment-location/last-known',
              {
                params: {
                  _version: '3.2',
                  _debug: 'true',
                },
              }
            );

            const rows = response.data?.data ?? [];
            return filteredDeduped(rows);
          },
        });
      } catch (error) {
        return [];
      }
    },
    [queryClient, baseQueryKey, axios]
  );
}
